//@flow
import Constants   from   "../constants";
import Dispatcher  from '../dispatcher';

export default {
  clearFilters() {
    Dispatcher.dispatchAction(Constants.CLEAR_FILTERS);
  },

  addFilter(name:string) {
    Dispatcher.dispatchAction(Constants.ADD_FILTER, { name });
  },

  removeFilter(name:string) {
    Dispatcher.dispatchAction(Constants.REMOVE_FILTER, { name });
  },

  toggleFilter(name:string) {
    Dispatcher.dispatchAction(Constants.TOGGLE_FILTER, { name });
  },

  toggleMobileFilters() {
    Dispatcher.dispatchAction(Constants.TOGGLE_MOBILE_FILTERS);
  },
};
